// ['ads', 'analytic', 'api', 'comment', 'other', 'social', 'support', 'technical', 'video']
import ads from '../group/AdsGroup'
import analytic from '../group/AnalyticGroup'
import technical from '../group/TechnicalGroup'
import social from '../group/SocialGroup'
import video from '../group/VideoGroup'

const groups = {
  ads,
  analytic,
  technical,
  social,
  video
}
export default class GroupManager {
  constructor() {
    this.groups = this.getGroups()
  }

  getGroups() {
    const arr = []
    for (const group in groups) {
      arr.push(this.getGroup(group))
    }
    return arr
  }

  getGroup(key) {
    const obj = groups[key]
    return new obj()
  }
}
